module.exports = __webpack_public_path__ + "img/reject-logo.04c6c456.png";